import CivilClusterPage from "./seo/CivilClusterPage";

export default function PreStartChecklistNZ() {
  return <CivilClusterPage pageKey="prestarts" />;
}
